import React from 'react';
import { Box, Inscription, RoundCloseIcon } from '@common-fe/common-fe';

interface Props {
  testId?: string;
  title: string;
}

const MatchingListEmptyState: React.FC<Props> = ({ testId, title }) => (
  <Box
    data-testid={`${testId}_empty-state`}
    align="center"
    round="container2Round"
    pad={{ vertical: 'spacing16', horizontal: 'spacing24' }}
    border={{ size: '1px', color: 'border1' }}
  >
    <RoundCloseIcon color="iconSecondary" size="spacing24" />
    <Inscription 
      margin={{ top: 'spacing8' }}
      color="textDisabled"
      weight={700}
    >
      {title}
    </Inscription>
  </Box>
);

export default MatchingListEmptyState;
